import {useEffect} from 'react';
import {useAppSelector} from '@/hooks';
import {
  enableVersionHistoryShortcuts,
  disableVersionHistoryShortcuts,
  disablePosterEditorShortcuts,
  enablePosterEditorShortcuts,
} from '@PosterWhiteboard/poster/poster-editor-shortcuts';
import {isPosterPushModalOpen} from '@Components/modal-container/modal-container-reducer';

export const useVersionHistoryShortcuts = (): void => {
  const isVersionHistoryModeActive = useAppSelector((state) => {
    return state.posterEditor.isVersionHistoryModeActive;
  });
  const isPosterPushModalOpened = useAppSelector(isPosterPushModalOpen);

  useEffect(() => {
    if (isVersionHistoryModeActive) {
      disablePosterEditorShortcuts();
      enableVersionHistoryShortcuts();
    } else {
      if (isPosterPushModalOpened) {
        return;
      }
      disableVersionHistoryShortcuts();
      enablePosterEditorShortcuts();
    }
  }, [isVersionHistoryModeActive, isPosterPushModalOpened]);
};
